import React from 'react';

import { Box, Skeleton, Typography } from '@mui/material';
import Button from 'components/V2/Button';
import PropTypes from 'prop-types';
import { BOOKING_CHANNELS_COPY, BOOKING_CHANNELS_SKELETON } from 'views/V2/Integration/constants';

import styles from './channelSelectionInfo.module.css';

/**
 * Left: the selection count, switching to a "shown" phrasing while a search is
 * active. Right: Select all / Clear all, disabled per the design rules — each
 * against the currently *visible* rows, not the full catalogue, so both can be
 * disabled at once when a search matches nothing.
 */
function ChannelSelectionInfo({
    selectedCount,
    totalCount,
    shownCount,
    isSearchActive,
    onSelectAll,
    onClearAll,
    selectAllDisabled,
    clearAllDisabled,
    disabled = false,
    isLoading = false,
}) {
    const countText = isSearchActive
        ? BOOKING_CHANNELS_COPY.countShown(shownCount, totalCount)
        : BOOKING_CHANNELS_COPY.countSelected(selectedCount, totalCount);

    return (
        <Box className={styles.container}>
            {isLoading ? (
                <Skeleton
                    {...BOOKING_CHANNELS_SKELETON.commonSkeletonProps}
                    className={styles.countSkeleton}
                />
            ) : (
                <Typography className={styles.countText}>{countText}</Typography>
            )}
            <Box className={styles.actions}>
                <Button
                    className={styles.actionBtn}
                    onClick={onSelectAll}
                    disabled={disabled || selectAllDisabled}
                >
                    {BOOKING_CHANNELS_COPY.SELECT_ALL}
                </Button>
                <Box className={styles.divider} />
                <Button
                    className={styles.actionBtn}
                    onClick={onClearAll}
                    disabled={disabled || clearAllDisabled}
                >
                    {BOOKING_CHANNELS_COPY.CLEAR_ALL}
                </Button>
            </Box>
        </Box>
    );
}

ChannelSelectionInfo.propTypes = {
    selectedCount: PropTypes.number.isRequired,
    totalCount: PropTypes.number.isRequired,
    shownCount: PropTypes.number.isRequired,
    isSearchActive: PropTypes.bool,
    onSelectAll: PropTypes.func.isRequired,
    onClearAll: PropTypes.func.isRequired,
    selectAllDisabled: PropTypes.bool,
    clearAllDisabled: PropTypes.bool,
    disabled: PropTypes.bool,
    isLoading: PropTypes.bool,
};

export default ChannelSelectionInfo;
